import { Component, Input, OnInit } from '@angular/core';
import { BaseSite, CmsComponent, CmsLinkListComponent } from '@kion/data-models';
import { CmsComponentsFacade } from '@kion/data-access/data-access-cms-components';
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { BaseSitesFacade } from '@kion/data-access/data-access-base-sites';
import { CmsConfig } from '../../config/cms.config';

@Component({
  selector: 'kion-cms-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  @Input() component: CmsLinkListComponent;

  private component$: BehaviorSubject<CmsLinkListComponent> = new BehaviorSubject<CmsLinkListComponent>(null);

  lazyComponents$: Observable<CmsComponent[]>;
  baseSite$: Observable<BaseSite>;

  constructor(private cmsComponentsFacade: CmsComponentsFacade, private baseSitesFacade: BaseSitesFacade, private cmsConfig: CmsConfig) { }

  ngOnInit(): void {
    this.baseSite$ = this.baseSitesFacade.all$.pipe(
      map(
        (baseSites: BaseSite[]) => baseSites.find(
          (baseSite: BaseSite) => baseSite.id === this.cmsConfig.baseSite
        )
      )
    );
    const links = this.component.links?.split(' ') || [];
    this.cmsComponentsFacade.loadByIds(links, links.join('_'));
    this.lazyComponents$ = combineLatest(
      [
        this.cmsComponentsFacade.all$,
        of(this.component)
      ]
    ).pipe(
      distinctUntilChanged(
        ([a, a1], [b, b1] ) => a === b
      ),
      map(
        ([cmsComponents, linkListComponent]) => {
          const components = linkListComponent ? linkListComponent.links ? linkListComponent.links.split(' ') : [] : [];
          return cmsComponents.filter(
            (cmsComponent: CmsComponent) => components.find(component => component === cmsComponent.uid)
          ).sort(
            (a: CmsComponent,b: CmsComponent) => {
              const indexA = components.indexOf(a.uid);
              const indexB = components.indexOf(b.uid);
              return indexA < indexB ? -1 : 1;
            }
          )
        }
      )
    );
  }
}
